export default __webpack_public_path__ + "static/media/profile-img.7e607d66.jpg";